<template>
  <div style="background-color:#F2F1EE;margin: auto; text-align: center;min-height: 100vh;">
    <img
      style="width: 80%;"
      :src="src"
    >
  </div>
</template>

<script>
export default {
  name: 'MockImage',
  props: {
    src: {
      type: String,
    },
  },
  mounted() {
    console.log('Mounted');
  },
};
</script>
